import createReducer from 'topmeteo/base-image/reducer';

import {OSM, Region} from './actions';

export default initialState => createReducer({...initialState, confirmRegionChange: null}, {
    [OSM.Layer]: (state, layer) => ({OSMLayer: layer}),
    [OSM.Colored]: (state, colored) => ({OSMColored: colored}),
    [OSM.Opacity]: (state, opacity) => ({OSMOpacity: opacity}),
    [OSM.FAI]: (state, FAIEnabled) => ({FAIEnabled}),
    [Region.confirmChange]: (state, confirmRegionChange) => ({confirmRegionChange}),
});
